import { always, platformModifierKeyOnly } from "ol/events/condition";
import { Extent } from "ol/extent";
import { DragBox } from "ol/interaction";

export class DragZoomWithPadding extends DragBox {

  padding:[number,number,number,number] = [0,0,0,0];

  constructor(options = {}) {
    super({
      condition: always,
      className: 'ol-dragzoom-box',
      ...options
    });
  }

  override onBoxEnd() {
    const extent = this.getGeometry().getExtent();
    this.getMap().getView().fit(extent, {
      padding: this.padding,
      duration: 250,
      size: this.getMap().getSize()
    });
  }

  setPadding(padding:[number,number,number,number] )
  {
    this.padding = padding;
  }
}
